export const PUSHNOTIFICATIONS_RESET_STATE = 'PUSHNOTIFICATIONS_RESET_STATE';
export const PUSHNOTIFICATIONS_CURRENT_ITEM = 'PUSHNOTIFICATIONS_CURRENT_ITEM';

export const PUSHNOTIFICATIONS_REQUEST_LOADING = 'PUSHNOTIFICATIONS_REQUEST_LOADING';
export const PUSHNOTIFICATIONS_REQUEST_SUCCESS = 'PUSHNOTIFICATIONS_REQUEST_SUCCESS';
export const PUSHNOTIFICATIONS_REQUEST_FAILED = 'PUSHNOTIFICATIONS_REQUEST_FAILED';

export const PUSHNOTIFICATIONS_CURRENT_ACTION = 'PUSHNOTIFICATIONS_CURRENT_ACTION';
export const PUSHNOTIFICATIONS_RESET_ACTION = 'PUSHNOTIFICATIONS_RESET_ACTION';